import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

import homeImage from '../assets/images/home.jpg';
import logo from '../assets/images/hult-ashridge-logo-white.svg';

const Index: TemplateOnlyComponent = <template>
  <div class="text-bg-primary">
    <div class="container py-4 d-flex flex-row gap-3 align-items-center">
      <img
        src={{logo}}
        alt="Hult Ashridge Executive Education"
        class="img-fluid mw-400px"
      />
    </div>
  </div>
  <div class="container py-5">
    <div class="row mb-4">
      <div class="col-lg-6 pe-lg-5 mb-5 mb-lg-0">
        <h1>Welcome to Admin<span
            class="text-hultashridge-heritage"
          >·2</span></h1>
        <p class="lead mb-5">
          This is your centralized hub for managing programs, publishing
          content, and configuring access to our digital portfolio.
        </p>
        <div class="d-flex flex-column gap-2">
          <LinkTo @route="programs" class="btn btn-primary">Manage programs</LinkTo>
          <LinkTo @route="library.clients" class="btn btn-primary">Manage
            clients</LinkTo>
        </div>
      </div>
      <div class="col-lg-6">
        <img
          src={{homeImage}}
          alt="People arranging post-it notes"
          class="img-fluid rounded-5"
        />
      </div>
    </div>
  </div>
</template>;

export default Index;
